// В style.css у html стоит overflow: hidden, а прокручивается body.
// Safari (macOS/iOS) в такой схеме не всегда выполняет scrollIntoView,
// поэтому сами находим прокручиваемый контейнер и крутим его через scrollTo.

export function getScrollParent(element) {
	let parent = element.parentElement
	while (parent) {
		const { overflowY } = window.getComputedStyle(parent)
		if (
			(overflowY === 'auto' || overflowY === 'scroll') &&
			parent.scrollHeight > parent.clientHeight
		) {
			return parent
		}
		parent = parent.parentElement
	}
	return document.scrollingElement || document.documentElement
}

export function scrollToElement(element) {
	if (!element) return
	const container = getScrollParent(element)
	const isRoot = container === document.scrollingElement || container === document.documentElement
	const containerTop = isRoot ? 0 : container.getBoundingClientRect().top
	const top = container.scrollTop + element.getBoundingClientRect().top - containerTop

	if (
		typeof container.scrollTo === 'function' &&
		'scrollBehavior' in document.documentElement.style
	) {
		container.scrollTo({ top, behavior: 'smooth' })
	} else {
		// старые Safari не понимают behavior: 'smooth' — прокручиваем без анимации
		container.scrollTop = top
	}
}
